import { DATE_OPTIONS_DEFINITIONS } from 'wflow-cdk';
import { InvoiceTypeEnum } from 'wflow-variables';
import { PeppolItemDirection } from '../../../interfaces/peppol-item.interface';
import { PEPPOL_STATUS_FILTER_VALUES } from '../../../const/peppol-status.const';
import {
  PeppolDocumentFilter,
  PeppolFilter,
  PeppolFilterKey,
} from '../peppol-items.interface';

const allowedDateOptionsSet = new Set([
  'today',
  'yesterday',
  'last-7-days',
  'last-14-days',
  'last-30-days',
  'preview-quarter',
  'preview-year',
]);

const dateFilterOptions = [
  ...DATE_OPTIONS_DEFINITIONS.flatMap((filter) => {
    if (allowedDateOptionsSet.has(String(filter.key))) {
      return [{ value: filter.key, label: filter.value }];
    }
    return [];
  }),
  { value: 'custom', label: 'FILTERS.DATE.Custom' },
];

export const PEPPOL_FILTER_DEFINITIONS: Record<PeppolFilterKey, PeppolFilter> =
  {
    direction: {
      key: 'direction',
      label: 'PEPPOL.FILTERS.Direction',
      icon: 'mail_01',
      options: [
        { value: PeppolItemDirection.Incoming, label: 'PEPPOL.Inbox' },
        { value: PeppolItemDirection.Outgoing, label: 'PEPPOL.Outbox' },
      ],
    },
    status: {
      key: 'status',
      label: 'PEPPOL.FILTERS.Status',
      icon: 'check_circle',
      options: PEPPOL_STATUS_FILTER_VALUES.map((value) => ({
        value,
        label: `PEPPOL.STATUS.${value}`,
      })),
    },
    document: {
      key: 'document',
      label: 'PEPPOL.FILTERS.Document',
      icon: 'file_check_03',
      options: Object.values(PeppolDocumentFilter).map((value) => ({
        value,
        label: `PEPPOL.FILTERS.DOCUMENT.${value}`,
      })),
    },
    sender: {
      key: 'sender',
      label: 'PEPPOL.FILTERS.Sender',
      icon: 'building_07',
      options: [],
      freeTextMode: true,
    },
    receiver: {
      key: 'receiver',
      label: 'PEPPOL.FILTERS.Receiver',
      icon: 'building_07',
      options: [],
      freeTextMode: true,
    },
    partner: {
      key: 'partner',
      label: 'PEPPOL.FILTERS.Partner',
      icon: 'building_07',
      options: [],
      freeTextMode: true,
    },
    invoiceType: {
      key: 'invoiceType',
      label: 'PEPPOL.FILTERS.InvoiceType',
      icon: 'file_06',
      options: Object.values(InvoiceTypeEnum).map((value) => ({
        value,
        label: `DocumentInvoiceType_${value}`,
      })),
    },
    user: {
      key: 'user',
      label: 'PEPPOL.FILTERS.User',
      icon: 'user_circle',
      options: [],
      freeTextMode: true,
    },
    date: {
      key: 'date',
      label: 'PEPPOL.FILTERS.Date',
      icon: 'calendar',
      options: dateFilterOptions,
    },
  };
